import isPropValid from "@emotion/is-prop-valid";
import styled from "@emotion/styled";

type TableProps = {
  scroll?: boolean;
};

const TableWrapper = styled("div", {
  shouldForwardProp: (prop) => isPropValid(prop) && prop !== "scroll",
})<TableProps>(({ scroll = false, theme }) => {
  let wrapperCSS = {};

  if (scroll === true) {
    wrapperCSS = {
      "@media (max-width: 830px)": {
        marginBottom: "2rem",
        marginLeft: "-1rem",
        marginRight: "-1rem",
        position: "relative",
        width: "auto",
        "&::after": {
          content: "''",
          position: "absolute",
          right: 0,
          top: 0,
          bottom: 0,
          width: "1rem",
          backgroundImage: `linear-gradient(90deg, transparent 0%, ${theme.colors.green} 95%)`,
        },
        "&>div": {
          overflow: "auto",
          paddingRight: "1rem",
        },
        table: {
          marginBottom: "1rem",
          marginLeft: "1rem",
          minWidth: "100%",
        },
        "td,th": {
          width: "33vw",
          minWidth: "calc(10em + 12vw)",
        },
        "@media (min-width: 600px) and (max-width: 830px)": {
          marginLeft: "-3.2rem",
          marginRight: "-3.2rem",
          maxWidth: "calc(100vw + 6.4rem)",
          "&::after": {
            width: "3.2rem",
          },
          "&>div": {
            paddingRight: "3.2rem",
          },
          table: {
            marginLeft: "3.2rem",
          },
        },
      },

      "@media (min-width: 831px)": {
        width: "100%",
        maxWidth: "100%",
      },
    } as const;
  }

  return { ...wrapperCSS };
});

const TableElement = styled("table")(({ theme }) => ({
  borderCollapse: "collapse",
  margin: "2rem 0",
  width: "100%",
  "&,*": { fontSize: theme.fontSizes.xs },
  p: {
    marginBottom: ".5em",
  },
  "th,td": {
    border: `1px solid ${theme.colors.fg}`,
    padding: theme.spacing.sm,
    textAlign: "left",
    verticalAlign: "top,",
  },
  "@media (min-width: 600px)": {
    "th,td": {
      padding: theme.spacing.md,
    },
  },
}));

type Props = {
  children: React.ReactNode;
} & React.ComponentProps<typeof TableWrapper>;

function Table({ children, ...props }: Props) {
  return (
    <TableWrapper {...props}>
      <div>
        <TableElement>{children}</TableElement>
      </div>
    </TableWrapper>
  );
}

export { Table };
